// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import TurboPower from "turbo_power"
TurboPower.initialize(Turbo.StreamActions)
import "trix"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()
import "./controllers"
